import { z } from "zod";
import { AiArtifact } from "./ai.ts";
import { PreparationDraft } from "./preparation-draft.ts";
import { Ref, sameRef } from "./primitives.ts";

/** Stable identities of built-in wire schemas, not tenant grants or catalog capabilities.
 * Incompatible changes require a new version and an explicit reader migration. */
export const AiSystemContractRefs = Object.freeze({
  artifact: Object.freeze({ id: "4d765809-0e3e-4f0c-87e9-59a4a16ec301", version: 1 }),
  workMessage: Object.freeze({ id: "4d765809-0e3e-4f0c-87e9-59a4a16ec302", version: 1 }),
  preparationDraft: Object.freeze({ id: "4d765809-0e3e-4f0c-87e9-59a4a16ec303", version: 2 }),
});
/** Immutable assistant message is the content store; descriptor is a deterministic projection. */
export const PreparationDraftArtifact = z.object({ artifact: AiArtifact, content: PreparationDraft }).strict().superRefine((value, ctx) => {
  const a = value.artifact;
  if (a.kind !== "REQUIREMENT_PROPOSAL" || a.version !== 1 || !sameRef(a.content.ref, a)
    || !sameRef(a.content.contractRef, AiSystemContractRefs.preparationDraft) || !a.provenanceRefs.length
    || a.provenanceRefs.some(source => source.ref.version !== 1 || (!sameRef(source.contractRef, AiSystemContractRefs.workMessage) && !sameRef(source.contractRef, AiSystemContractRefs.artifact))))
    ctx.addIssue({ code: "custom", message: "PREPARATION_ARTIFACT_INVALID" });
});
export type PreparationDraftArtifact = z.infer<typeof PreparationDraftArtifact>;
export const PreparationArtifactRef = Ref.refine(ref => ref.version === 1, "PREPARATION_ARTIFACT_VERSION_UNSUPPORTED");
